import client from './client';
import { KEY } from '../../utils/constants/storageKey';
import { clearHistory } from 'utils/nativeApi';
import store from 'store';
import { TELEMEDICINE_DATA_KEY } from '../../utils/constants/storageKey';

/** Account: access token 재발급 */
export const refreshAccessToken = async (refreshToken) => {
  const res = await client.post('/account/auth/refresh', {
    refresh_token: refreshToken,
  });
  return res.data;
};

/** Account: Account 정보 조회 */
export const getAccountInfo = async () => {
  const res = await client.get('my/account');
  return res.data;
};

// Account : 로그인
export const login = async ({ email, password }) => {
  return client.post('/account/auth/b2c', { email, password });
};

// Account : 이메일 중복 확인
export const checkEmail = (email) =>
  client.get('/account/duplicates?email=' + email);

// Account : 회원가입
export const register = ({ email, password }) =>
  client.post('/account/join/b2c', { email, password });

// Account : KB 회원가입
export const registerKb = ({ inKey }) =>
  client.post('/account/kb-ocare/register', {
    inKey,
  });
/** Account: FCM 토큰 제거 */
export const removeFcmToken = () =>
  client.put(`/my/account/fcm-token/unregister`);

// Account : 로그아웃
// export const logout = () => client.post('/api/account/logout');
export const logout = async () => {
  try {
    localStorage.removeItem(KEY); //자동로그인 체크한 사용자
    sessionStorage.removeItem(KEY); //자동로그인 체크하지 않은 사용자
    store.remove(TELEMEDICINE_DATA_KEY);
    clearHistory();
    window.location.replace(`${window.location.origin}`); //브라우저 리프레시하며 Redux Store 초기화 & 메인 화면으로 보냄
  } catch (e) {
    console.log('localStorage/sessionStorage is not working');
  }
};

// Account : 탈퇴하기
export const dropout = () => {
  console.log('drop out api ');
  return client.post('/my/account/dropout');
};

// Account : axios header authorization 기본 설정(로그인 후)
export const setAuthorization = (accessToken) => {
  console.group('Account API - setAuthorization');
  console.groupEnd();

  client.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
};

// Account : 비밀번호 분실 시 재설정 위한 email 인증, 코드 인증, 비밀번호 재설정
export const checkForgot = (email) =>
  client.post('/account/forgot/email', email);

export const verifyForgot = ({ forgot_id, verification_code }) =>
  client.post('/account/forgot/verify', { forgot_id, verification_code });

export const changeForgot = ({ forgot_id, new_password }) =>
  client.post('/account/forgot/change', { forgot_id, new_password });

// Account : 로그인 후 비밀번호 변경
export const changePassword = ({ current_password, new_password }) =>
  client.put('/my/account/password', { current_password, new_password });

// Account : 핸드폰 번호 중복 확인
export const checkDuplicatePhoneNumber = (phone_number) =>
  client.get(`/account/duplicates?phone_number=${phone_number}`);

// Account : 이메일 인증 번호 요청
export const requestVerifycationCodeMail = (email, region) =>
  client.post(`/account/join/foreigner/${region}`, { email });

// Account : 이메일 인증 번호 검증
export const verifyCode = (region, temporaryId, verificationCode) =>
  client.post(`/account/join/foreigner/${region}/${temporaryId}/verify/email`, {
    verification_code: String(verificationCode),
  });

// Account : foreign 회원 비밀번호 등록
export const registerforeignPW = (region, temporaryId, password) =>
  client.post(`/account/join/foreigner/${region}/${temporaryId}/password`, {
    password,
  });

// Account : foreign 약관, 닉네임 등록
export const addTermsAndNickname = (region, temporaryId, userInform) =>
  client.post(`/account/join/foreigner/${region}/${temporaryId}/basic`, {
    nickname: userInform.nickname,
    service_term: userInform.termsService,
    privacy_term: userInform.termsPrivacy,
    sensitivity_term: userInform.termsSensitivity,
    marketing_agreement: userInform.termsMarketing,
  });

// Account : foreign 회원등록 최종제출 가입완료처리
export const addForeignUserFinalize = (region, temporaryId) =>
  client.post(`/account/join/foreigner/${region}/${temporaryId}/finalize`);

/** Account: FCM 토큰 등록 */
export const registerFcmToken = async (fcm_token) => {
  try {
    client.put(`/my/account/fcm-token/register`, {
      fcm_token: fcm_token,
    });
  } catch (e) {
    alert('Fcm token Err');
  }
};

// /** Account: 앱 푸쉬 여부 확인 */
// export const checkAppPushAgreement = () =>
//   client.get(`/my/account/push-agreement`);

// /** Account: 앱 푸쉬 수신 동의 */
// export const confirmAppPushAgreement = () =>
//   client.put(`/my/account/push-agreement`, {
//     is_agree: true,
//   });
